import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconExclamationMarkTriangle20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconExclamationMarkTriangle20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M11.964 2.227c-.859-1.536-3.07-1.536-3.928 0L1.092 14.652C.254 16.152 1.338 18 3.056 18h13.887c1.718 0 2.803-1.848 1.964-3.348zm-2.619.732a.75.75 0 0 1 1.31 0l6.943 12.425a.75.75 0 0 1-.655 1.116H3.056a.75.75 0 0 1-.654-1.116zm-.095 8.54V7a.75.75 0 1 1 1.5 0v4.5a.75.75 0 0 1-1.5 0m1.75 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconExclamationMarkTriangle20);
